<template lang="pug">
  base-side-nav(:items='menuItems')
</template>

<script>
import BaseSideNav from "@/shared/components/BaseSideNav";

export default {
  components: { BaseSideNav },
  data() {
    return {
      menuItems: [
        {
          label: "Dashboard",
          icon: "home",
          routeName: "companyAdmin:dashboard"
        },
        {
          label: "Groups",
          icon: "group",
          routeName: "companyAdmin:permissions"
        },
        {
          label: "Users",
          icon: "user-circle-o",
          routeName: "companyAdmin:users"
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss"></style>
